import { invoices, companies, statistics } from '@/api/didox';

export const actions = {
  getInvoices({ commit }, params) {
    return new Promise((resolve, reject) => {
      invoices(params)
        .then(res => {
          if (res['success'] && res['data']) {
            commit('SET_INVOICES', res['data']);
          }
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  getCompanies({ commit }, params) {
    return new Promise((resolve, reject) => {
      companies(params)
        .then(res => {
          if (res['success'] && res['data']) {
            commit('SET_COMPANIES', res['data']);
          }
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  getStatistics({ commit }, params) {
    return new Promise((resolve, reject) => {
      statistics(params)
        .then(res => {
          if (res['success'] && res['data']) {
            commit('SET_STATISTICS', res['data']);
          }
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
};
